import { render } from "./SerialMail.vue?vue&type=template&id=4b4e62aa"
import script from "./SerialMail.vue?vue&type=script&lang=js"
export * from "./SerialMail.vue?vue&type=script&lang=js"
script.render = render

export default script